<!-- <app-sliding-campaign-cards
  [featuredCampaigns]="campaigns"
></app-sliding-campaign-cards> -->

<div class="main_div">
  <div class="breadcrumb">
    @if(!public){
    <span class="donation_title"> Manage > </span>
    <span> My NGO/NPO </span>
    }
  </div>

  <div
    style="
      width: 85%;
      margin-inline: auto;
      margin-top: 64px;
      display: flex;
      flex-direction: column;
      gap: 32px;
    "
  >
    <div
      [ngClass]="
        !editorOpened[15] ? 'ngo_profile_details' : 'ngo_profile_details2'
      "
    >
      <ng-container *ngIf="!editorOpened[15]; else ngoInformationEditMode">
        <div
          class="img_slider"
          [ngStyle]="{
            'background-image': coverPhotoUrl
          }"
        >
          @if(!public){

          <div
            class="edit_trigger_div cursor"
            (click)="openEditor(15, false, 'cover')"
          >
            <img
              *ngIf="!editorOpened[15]"
              class="cross_icon cursor"
              style="margin-right: 8px"
              title="Remove Image"
              src="../../../../assets/images/icon/camera-add.svg"
            />
            <span class="Edit_text">Edit Cover Photo</span>
          </div>
          }
        </div>
        <div class="d-flex align-items-start w-100" style="gap: 16px">
          <div class="ngo_logo_background">
            <img
              class="profile_img_img2"
              [src]="
                ngoLogo?.url ?? '../../../../assets/images/icon/shadow_logo.svg'
              "
            />
            @if(!public){
            <img
              *ngIf="ngoLogo?.url"
              class="logo_edit_icon cursor"
              title="Edit Image"
              src="../../../../assets/images/icon/frame-camera.svg"
              (click)="openEditor(15, false, 'profile')"
            />
            }
          </div>
          <div class="d-flex flex-column g-1" style="width: 85%">
            <div
              class="d-flex w-100 p-2 details justify-content-between align-items-end"
              style="margin-bottom: 16px"
            >
              <div class="title">
                {{ editedNgoBody?.name ? editedNgoBody?.name : "No Data!" }}
                <img
                  *ngIf="editedNgoBody?.is_verified"
                  src="../../../../assets/images/icon/verified_icon_green.svg"
                  alt="Verified"
                  title="Copy URL"
                />
              </div>

              @if(!public){

              <div
                class="edit_name cursor"
                (click)="openEditor(15, false, 'info')"
              >
                <img
                  src="../../../../assets/images/icon/pencil-edit-new.svg"
                  style="margin-right: 8px"
                  alt="Change Information"
                  title="inf"
                  width="24px"
                  height="24px"
                />
                <span class="Edit_text">Update</span>
              </div>
              }
            </div>
            <div
              class="description"
              style="margin-bottom: 16px; margin-left: 8px"
            >
              {{
                editedNgoBody?.key_activities
                  ? editedNgoBody?.key_activities
                  : "No Data!"
              }}
            </div>
            <div class="info" style="margin-bottom: 16px; margin-left: 8px">
              <img
                class="edit_button"
                src="../../../../../assets/images/icon/phone_new.svg"
              />
              <span class="info" style="margin-right: 8px">
                {{ editedNgoBody?.phone ? editedNgoBody?.phone : "No Data!" }}
              </span>
              <img class="edit_button" src="./assets/images/icon/msg_new.svg" />
              <span class="info" style="margin-right: 8px">
                {{ editedNgoBody?.email ? editedNgoBody?.email : "No Data!" }}
              </span>
              <img lass="edit_button" src="./assets/images/icon/web_new.svg" />
              <span class="info" style="margin-right: 8px">
                {{
                  editedNgoBody?.website ? editedNgoBody?.website : "No Data!"
                }}
              </span>
            </div>
            <div class="info" style="margin-bottom: 16px; margin-left: 8px">
              <img class="edit_button" src="./assets/images/icon/add_new.svg" />
              <span class="info">
                {{
                  editedNgoBody?.address ? editedNgoBody?.address : "No Data!"
                }}
              </span>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #ngoInformationEditMode>
        @if(ngoInfoEdit){
        <div
          class="img_slider border border-primary"
          [ngStyle]="{
            'background-image': 'url(' + ngoProfilePic?.url + ')'
          }"
        ></div>
        <div class="d-flex align-items-start w-100" style="flex-wrap: wrap">
          <!-- <div class="logo_part"> -->
          <!-- <div
                [ngClass]="ngoLogo?.url ? 'edit_ngo_logo' : 'edit_ngo_logo center'"
                style="width: 15%; align-items: start"
              > -->
          <div
            class="ngo_logo_background"
            [ngStyle]="{ 'background-image': 'url(' + ngoLogo?.url + ')' }"
          ></div>
          <div class="d-flex flex-column g-1" style="width: 85%">
            <div class="title">
              {{ editedNgoBody?.name ? editedNgoBody?.name : "No Data!" }}
              <img
                *ngIf="editedNgoBody?.is_verified"
                src="../../../../assets/images/icon/verified_icon_green.svg"
                alt="Verified"
                title="Copy URL"
              />
            </div>
            <div class="row">
              <div class="col-lg-12">
                <label class="field_label requiredMark">Bio</label>
                <dx-text-area
                  class="text_area_field"
                  placeholder="Mention your main programs and projects. What services or programs does your NGO provide? Who are the beneficiaries (children, women, refugees, etc.)?
                "
                  [(ngModel)]="editedNgoBody.key_activities"
                >
                  <dx-validator validationGroup="validationGrp">
                    <dxi-validation-rule
                      type="required"
                      message="You must write your NGO key activities."
                    >
                    </dxi-validation-rule>
                  </dx-validator>
                </dx-text-area>
              </div>

              <div class="col-lg-6">
                <label class="field_label requiredMark">Address</label>
                <dx-text-box
                  class="input_field"
                  placeholder="Physical address of your NGO’s headquarter"
                  [showClearButton]="true"
                  [(ngModel)]="editedNgoBody.address"
                >
                  <dx-validator validationGroup="validationGrp">
                    <dxi-validation-rule
                      type="required"
                      message="Address is required"
                    >
                    </dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>

              <div class="col-lg-6">
                <label class="field_label requiredMark">Phone</label>
                <dx-text-box
                  class="input_field"
                  placeholder="NGO’s primary contact number"
                  [showClearButton]="true"
                  [(ngModel)]="editedNgoBody.phone"
                >
                  <dx-validator validationGroup="validationGrp">
                    <dxi-validation-rule
                      type="required"
                      message="Phone number is required."
                    >
                    </dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>

              <div class="col-lg-6">
                <label class="field_label requiredMark">Email</label>
                <dx-text-box
                  class="input_field"
                  placeholder="NGO’s official email address"
                  [showClearButton]="true"
                  [(ngModel)]="editedNgoBody.email"
                >
                  <dx-validator validationGroup="validationGrp">
                    <dxi-validation-rule
                      type="required"
                      message="Email is required."
                    ></dxi-validation-rule>
                    <dxi-validation-rule
                      type="email"
                      message="Email is invalid. Ex: jone@gmail.com"
                    >
                    </dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>

              <div class="col-lg-6">
                <label class="field_label">Website</label>
                <dx-text-box
                  class="input_field"
                  placeholder="NGO’s website URL"
                  [showClearButton]="true"
                  [(ngModel)]="editedNgoBody.website"
                >
                  <dx-validator validationGroup="validationGrp"> </dx-validator>
                </dx-text-box>
              </div>

              <div class="save_button_div">
                <button class="blue-button-md" (click)="onSaveMultiple()">
                  Save
                </button>
                <button class="white-button-md" (click)="openEditor(15, true)">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
        } @if(ngoProfileEdit){
        <div class="Profile">
          <div class="title">Update Logo</div>
          <div
            [ngClass]="ngoLogo?.url ? 'edit_ngo_logo' : 'edit_ngo_logo center'"
          >
            <div class="ngo_logo_background_edit">
              <img class="profile_img_img2" [src]="ngoLogo?.url" />
              <div style="position: relative; width: 100%">
                <img
                  class="cross_icon cursor"
                  title="Remove Image"
                  style="position: absolute; top: 0; right: 10%"
                  src="../../../../assets/images/icon/cross-icon.svg"
                  (click)="removeImage('ngoLogo', 'logo_url')"
                />
              </div>
            </div>
          </div>

          <input
            #fileInput
            type="file"
            id="logoFile"
            accept=".jpg, .jpeg, .png, .svg,"
            style="display: none"
            (change)="onFileSelected($event, 'ngoLogo')"
          />
          <div style="width: 87%">
            <button
              class="white-button-md mt-3"
              type="button"
              style="margin-inline: 50%"
              (click)="triggerFileInput('logoFile')"
            >
              {{ ngoLogo?.url ? "Change Picture" : "Add Picture" }}
            </button>
          </div>
          <div class="save_button_div">
            <button class="yellow-button-md" (click)="openEditor(15, true)">
              Cancel
            </button>
            <button
              class="blue-button-md"
              (click)="onSaveSingle(15, 'ngoLogo', 'logo_url')"
            >
              Save
            </button>
          </div>
        </div>
        } @if(coverEdit){

        <div class="Profile">
          <div class="title">Update Cover</div>
          <div class="profile_img_div">
            <img class="profile_img_img" [src]="ngoProfilePic?.url" />
            <img
              class="cross_icon cursor"
              style="position: absolute; top: 0; right: 0%"
              title="Remove Image"
              src="../../../../assets/images/icon/cross-icon.svg"
              (click)="removeImage('ngoProfilePic', 'ngo_profile_img_url')"
            />
            <!-- <div *ngIf="ngoProfilePic?.url" class="profile_img">
              <div style="position: relative; width: 100%">
               
              </div>
            </div> -->
            <img
              *ngIf="!ngoProfilePic?.url"
              class="ngo_logo_img"
              alt="No Logo"
              [src]=""
            />
          </div>
          <input
            #fileInput
            type="file"
            id="ngoProfileImgFile"
            accept=".jpg, .jpeg, .png"
            style="display: none"
            (change)="onFileSelected($event, 'ngoProfilePic')"
          />
          <button
            class="white-button-md mt-3"
            type="button"
            (click)="triggerFileInput('ngoProfileImgFile')"
          >
            {{ ngoProfilePic?.url ? "Change Picture" : "Add Picture" }}
          </button>

          <div class="save_button_div">
            <button class="yellow-button-md" (click)="openEditor(15, true)">
              Cancel
            </button>
            <button
              class="blue-button-md"
              (click)="onSaveSingle(15, 'ngoProfilePic', 'ngo_profile_img_url')"
            >
              Save
            </button>
          </div>
        </div>
        }
      </ng-template>
    </div>

    <div class="card_div">
      <!--About us-->
      <div
        class="card shadow-sm mb-4"
        style="border-radius: 8px; border: none; padding: 32px"
      >
        <!-- View Mode -->
        <ng-container *ngIf="!editorOpened[11]; else aboutUsEditMode">
          <div
            class="d-flex justify-content-between align-items-center px-3 pt-3 pb-2"
          >
            <label class="header mb-4">About Us</label>

            @if(!public){
            <button class="btn btn-sm btn_fixed" (click)="openEditor(11)">
              <img
                src="./assets/images/icon/edit_icon_active.svg"
                alt="edit"
                class="me-1"
              />
              Update
            </button>
            }
          </div>

          <!--Vision-->
          <label class="sub-header mb-1 px-3">Vison</label>
          <ng-container *ngIf="editedNgoBody?.vision; else noVision">
            <div
              class="meta_container px-3 py-2 mb-3 address-row col whitespace_preserve"
            >
              <span>
                {{
                  expandedState[0]
                    ? editedNgoBody.vision
                    : truncate(editedNgoBody.vision, 150)
                }}
              </span>

              <button
                *ngIf="editedNgoBody.vision.length > 150"
                class="see-more-btn"
                (click)="toggleExpand(0)"
              >
                {{ expandedState[0] ? "See less" : "See more" }}
              </button>
            </div>
          </ng-container>

          <ng-template #noVision>
            <p class="text-gray mb-3 px-3" style="font-size: 0.9rem">
              No vision found!
            </p>
          </ng-template>

          <!--Our Mission-->
          <label class="sub-header mb-1 px-3">Our Mission</label>
          <ng-container *ngIf="editedNgoBody?.mission; else noMission">
            <div
              class="meta_container px-3 py-2 mb-3 address-row col whitespace_preserve"
            >
              <span>
                {{
                  expandedState[1]
                    ? editedNgoBody.mission
                    : truncate(editedNgoBody.mission, 170)
                }}
              </span>

              <button
                *ngIf="editedNgoBody.mission.length > 170"
                class="see-more-btn"
                (click)="toggleExpand(1)"
              >
                {{ expandedState[1] ? "See less" : "See more" }}
              </button>
            </div>
          </ng-container>

          <ng-template #noMission>
            <p class="text-gray mb-3 px-3" style="font-size: 0.9rem">
              No mission found!
            </p>
          </ng-template>

          <!--Our Values-->
          <label class="sub-header mb-1 px-3">Our Values</label>
          <ng-container *ngIf="editedNgoBody?.our_values; else noValues">
            <div
              class="meta_container px-3 py-2 mb-3 address-row col whitespace_preserve"
            >
              <span>
                {{
                  expandedState[2]
                    ? editedNgoBody.our_values
                    : truncate(editedNgoBody.our_values, 200)
                }}
              </span>

              <button
                *ngIf="editedNgoBody.our_values.length > 200"
                class="see-more-btn"
                (click)="toggleExpand(2)"
              >
                {{ expandedState[2] ? "See less" : "See more" }}
              </button>
            </div>
          </ng-container>

          <ng-template #noValues>
            <p class="text-gray mb-3 px-3" style="font-size: 0.9rem">
              No mission found!
            </p>
          </ng-template>

          <!-- Our Story -->
          <label class="sub-header mb-1 px-3">Our Story</label>
          <ng-container *ngIf="editedNgoBody?.our_story; else noStory">
            <div
              class="meta_container px-3 py-2 mb-3 address-row col whitespace_preserve"
            >
              <span>
                {{
                  expandedState[3]
                    ? editedNgoBody.our_story
                    : truncate(editedNgoBody.our_story, 350)
                }}
              </span>

              <button
                *ngIf="editedNgoBody.our_story.length > 350"
                class="see-more-btn"
                (click)="toggleExpand(3)"
              >
                {{ expandedState[3] ? "See less" : "See more" }}
              </button>
            </div>
          </ng-container>

          <ng-template #noStory>
            <p class="text-gray mb-3 px-3" style="font-size: 0.9rem">
              No Story found!
            </p>
          </ng-template>
        </ng-container>

        <!-- Edit Mode -->
        <ng-template #aboutUsEditMode>
          <div
            class="d-flex justify-content-between align-items-center px-3 pt-3 pb-2"
          >
            <label class="header">Update About Us</label>
          </div>

          <!-- Vision -->
          <div class="px-3 py-2">
            <label class="sub-header">Vision</label>
            <dx-text-area
              class="text_area_field"
              placeholder="Enter Vision"
              [(ngModel)]="editedNgoBody.vision"
              [maxLength]="250"
            >
              <dx-validator validationGroup="validationGrp">
                <dxi-validation-rule
                  type="stringLength"
                  [max]="250"
                  message="Maximum 250 characters allowed"
                >
                </dxi-validation-rule>
              </dx-validator>
            </dx-text-area>
            <div class="meta_note mt-1">Note: Max 250 characters.</div>
          </div>

          <!--Our Mission -->
          <div class="px-3 py-2">
            <label class="sub-header">Our Mission</label>
            <dx-text-area
              class="text_area_field"
              placeholder="Enter Our Mission"
              [(ngModel)]="editedNgoBody.mission"
              [maxLength]="400"
            >
              <dx-validator validationGroup="validationGrp">
                <dxi-validation-rule
                  type="stringLength"
                  [max]="400"
                  message="Maximum 250 characters allowed"
                >
                </dxi-validation-rule>
              </dx-validator>
            </dx-text-area>
            <div class="meta_note mt-1">Note: Max 400 characters.</div>
          </div>

          <!--Our Values -->
          <div class="px-3 py-2">
            <label class="sub-header">Our Values</label>
            <dx-text-area
              class="text_area_field"
              placeholder="Enter Our Values"
              [(ngModel)]="editedNgoBody.our_values"
              [maxLength]="500"
            >
              <dx-validator validationGroup="validationGrp">
                <dxi-validation-rule
                  type="stringLength"
                  [max]="500"
                  message="Maximum 250 characters allowed"
                >
                </dxi-validation-rule>
              </dx-validator>
            </dx-text-area>
            <div class="meta_note mt-1">Note: Max 500 characters.</div>
          </div>

          <!-- Our stroy -->
          <div class="px-3 py-2">
            <label class="sub-header">Our Story</label>
            <dx-text-area
              class="text_area_field"
              placeholder="Enter our Story"
              [(ngModel)]="editedNgoBody.our_story"
              [maxLength]="800"
            >
              <dx-validator validationGroup="validationGrp">
                <dxi-validation-rule
                  type="stringLength"
                  [max]="800"
                  message="Maximum 800 characters allowed"
                >
                </dxi-validation-rule>
              </dx-validator>
            </dx-text-area>
            <div class="meta_note mt-1">Note: Max 800 characters.</div>
          </div>

          <!-- Action Buttons -->
          <div class="save_button_div">
            <button class="blue-button-md" (click)="onSaveSingle(11)">
              Save
            </button>
            <button class="white-button-md" (click)="openEditor(11, true)">
              Cancel
            </button>
          </div>
        </ng-template>
      </div>

      <!-- Contact Information -->
      <div
        class="card shadow-sm mb-4"
        style="border-radius: 8px; border: none; padding: 32px"
      >
        <!-- View Mode -->
        <ng-container *ngIf="!editorOpened[9]; else workingAddressEditMode">
          <div
            class="d-flex justify-content-between align-items-center px-3 pt-3 pb-2"
          >
            <label class="header mb-4">Contact Information</label>
            @if(!public){

            <button class="btn btn-sm btn_fixed" (click)="openEditor(9)">
              <img
                src="./assets/images/icon/edit_icon_active.svg"
                alt="edit"
                class="me-1"
              />
              Update
            </button>

            }
          </div>

          <!-- Phone -->
          <label class="sub-header mb-1 px-3">Phone</label>
          <ng-container *ngIf="editedNgoBody?.phone; else noPhone">
            <div class="meta_container px-3 py-2 mb-3 address-row">
              <span>
                <img
                  src="./assets/images/icon/phone-call.svg"
                  alt="phone"
                  class="icon"
                />{{ editedNgoBody.phone }}</span
              >
            </div>
          </ng-container>

          <ng-template #noPhone>
            <p class="text-gray mb-3 px-3" style="font-size: 0.9rem">
              No phone number found!
            </p>
          </ng-template>

          <!-- Email -->
          <label class="sub-header mb-1 px-3">Email</label>
          <ng-container *ngIf="editedNgoBody?.email; else noEmail">
            <div class="meta_container px-3 py-2 mb-3 address-row">
              <span
                ><img
                  src="./assets/images/icon/email.svg"
                  alt="email"
                  class="icon"
                />
                {{ editedNgoBody.email }}</span
              >
            </div>
          </ng-container>

          <ng-template #noEmail>
            <p class="text-gray mb-2 px-3" style="font-size: 0.9rem">
              No email found!
            </p>
          </ng-template>

          <!-- Office Addres -->
          <label class="sub-header mb-1 px-3">Office Address</label>
          <ng-container *ngIf="editedNgoBody?.address; else noOfficeAddress">
            <div class="meta_container px-3 py-2 mb-3 address-row">
              <span>
                <img
                  src="./assets/images/icon/location_blue.svg"
                  alt="location"
                  class="icon"
                />{{ editedNgoBody.address }}</span
              >
            </div>
          </ng-container>

          <ng-template #noOfficeAddress>
            <p class="text-gray mb-2 px-3" style="font-size: 0.9rem">
              No office address found!
            </p>
          </ng-template>

          <!-- Working Address -->
          <label class="sub-header mb-1 px-3">Working Address</label>
          <ng-container *ngIf="hasValidAddress(); else noWorkingAddressData">
            <div class="meta_container px-3 py-2">
              <div *ngFor="let item of workingAddress" class="address-row">
                <span
                  ><img
                    src="./assets/images/icon/location_bg_icon.svg"
                    alt="location"
                    class="icon"
                /></span>
                <span
                  >Division:
                  {{ getLocationName(item.division, "division") }} </span
                >,
                <span
                  >District:
                  {{ getLocationName(item.district, "district") }} </span
                >,
                <span
                  >Upazila:
                  {{ getLocationName(item.upazila, "upazila") }} </span
                >,
                <span>Union: {{ getLocationName(item.union, "union") }} </span>,
                <span>Ward:{{ item.ward ? item.ward : " null" }}</span>
              </div>
            </div>
          </ng-container>

          <ng-template #noWorkingAddressData>
            <p class="text-gray mb-2 px-3" style="font-size: 0.9rem">
              No working address found!
            </p>
          </ng-template>
        </ng-container>

        <!-- Edit Mode -->
        <ng-template #workingAddressEditMode>
          <div
            class="d-flex justify-content-between align-items-center px-3 pt-3 pb-2"
          >
            <label class="header">Update Contact Information</label>
          </div>

          <!-- Phone -->
          <div class="px-3 py-2">
            <label class="sub-header requiredMark">Phone</label>
            <dx-text-box
              class="input_field"
              placeholder="NGO’s primary contact number"
              [showClearButton]="true"
              [(ngModel)]="editedNgoBody.phone"
            >
              <dx-validator validationGroup="validationGrp">
                <dxi-validation-rule
                  type="required"
                  message="Phone number is required."
                ></dxi-validation-rule>
              </dx-validator>
            </dx-text-box>
          </div>

          <!-- Email -->
          <div class="px-3 py-2">
            <label class="sub-header requiredMark">Email</label>
            <dx-text-box
              class="input_field"
              placeholder="NGO’s official email address"
              [showClearButton]="true"
              [(ngModel)]="editedNgoBody.email"
            >
              <dx-validator validationGroup="validationGrp">
                <dxi-validation-rule
                  type="required"
                  message="Email is required."
                ></dxi-validation-rule>
                <dxi-validation-rule
                  type="email"
                  message="Email is invalid. Ex: jone@gmail.com"
                >
                </dxi-validation-rule>
              </dx-validator>
            </dx-text-box>
          </div>

          <!-- Office Address -->
          <div class="px-3 py-2">
            <label class="sub-header requiredMark">Office Address</label>
            <dx-text-box
              class="input_field"
              placeholder="Physical address of your NGO’s headquarter"
              [showClearButton]="true"
              [(ngModel)]="editedNgoBody.address"
            >
              <dx-validator validationGroup="validationGrp">
                <dxi-validation-rule
                  type="required"
                  message="Address is required"
                >
                </dxi-validation-rule>
              </dx-validator>
            </dx-text-box>
          </div>

          <!-- Dynamic Working Adress Rows -->
          <label class="sub-header px-3 py-2">Working Address</label>
          <div
            *ngFor="let item of workingAddress; let i = index"
            class="px-3 py-2 border-bottom border-top"
          >
            <div class="d-flex gap-3 mb-2">
              <!-- division -->
              <div class="flex-fill">
                <h6 class="meta_title">
                  Division <span class="required-star text-danger">*</span>
                </h6>
                <dx-tag-box
                  style="min-height: 40px"
                  [dataSource]="locationsTree"
                  placeholder="Select Division"
                  [showClearButton]="true"
                  [showDropDownButton]="true"
                  [multiline]="false"
                  [displayExpr]="'divisionName'"
                  [valueExpr]="'divisionId'"
                  [(value)]="item.division"
                  (onValueChanged)="onDivisionChanged($event, i)"
                >
                  <dx-validator validationGroup="validationGrp">
                    <dxi-validation-rule
                      type="required"
                      message="Division is required"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-tag-box>
                <div class="meta_note mt-1">Note: You can select only one.</div>
              </div>

              <!-- district -->
              <div class="flex-fill">
                <h6 class="meta_title">
                  District <span class="required-star text-danger">*</span>
                </h6>
                <dx-tag-box
                  style="min-height: 40px"
                  [dataSource]="item.availableDistricts"
                  placeholder="Select District"
                  [showClearButton]="true"
                  [showDropDownButton]="true"
                  [multiline]="false"
                  [displayExpr]="'districtName'"
                  [valueExpr]="'districtId'"
                  [(value)]="item.district"
                  (onValueChanged)="onDistrictChanged($event, i)"
                >
                  <dx-validator validationGroup="validationGrp">
                    <dxi-validation-rule
                      type="required"
                      message="District is required"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-tag-box>
                <div class="meta_note mt-1">Note: You can select only one.</div>
              </div>
            </div>

            <div class="d-flex gap-3 mb-2">
              <!-- Upazila -->
              <div class="flex-fill">
                <h6 class="meta_title">
                  Upazila <span class="required-star text-danger">*</span>
                </h6>
                <dx-tag-box
                  style="min-height: 40px"
                  [dataSource]="item.availableUpazilas"
                  placeholder="Select Upazila"
                  [showClearButton]="true"
                  [showDropDownButton]="true"
                  [multiline]="false"
                  [displayExpr]="'upazilaName'"
                  [valueExpr]="'upazilaId'"
                  [(value)]="item.upazila"
                  (onValueChanged)="onUpazilaChanged($event, i)"
                >
                  <dx-validator validationGroup="validationGrp">
                    <dxi-validation-rule
                      type="required"
                      message="Upazila is required"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-tag-box>
                <div class="meta_note mt-1">Note: You can select only one</div>
              </div>

              <!-- union -->
              <div class="flex-fill">
                <h6 class="meta_title">
                  Union <span class="required-star text-danger">*</span>
                </h6>
                <dx-tag-box
                  style="min-height: 40px"
                  [dataSource]="item.availableUnions"
                  placeholder="Select Union"
                  [showClearButton]="true"
                  [showDropDownButton]="true"
                  [searchEnabled]="true"
                  [multiline]="false"
                  [displayExpr]="'union_name'"
                  [valueExpr]="'union_id'"
                  [(value)]="item.union"
                  (onValueChanged)="onUnionChanged($event, i)"
                >
                  <dx-validator validationGroup="validationGrp">
                    <dxi-validation-rule
                      type="required"
                      message="Union is required"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-tag-box>
                <div class="meta_note mt-1">Note: You can select only one.</div>
              </div>
            </div>

            <div class="d-flex gap-3">
              <div class="flex-fill">
                <h6 class="meta_title">Ward / Village Name</h6>
                <dx-text-box
                  [(value)]="item.ward"
                  placeholder="Enter Ward or Village name"
                  [showClearButton]="true"
                >
                </dx-text-box>
                <div class="meta_note mt-1">Note: This field is optional.</div>
              </div>
            </div>

            <!-- Remove button -->
            <div
              class="d-flex justify-content-end pb-2"
              style="margin-top: 8px"
            >
              <button
                class="btn btn-outline-danger btn-sm"
                *ngIf="workingAddress.length > 1"
                (click)="removeAddress(i)"
              >
                Remove
              </button>
            </div>
          </div>

          <!-- Add Another Address Button -->
          <div class="px-3 py-2">
            <button
              class="btn btn-outline-primary btn-sm"
              (click)="addAddress()"
            >
              + Add another address
            </button>
          </div>

          <!-- Action Buttons -->
          <div class="save_button_div">
            <button class="blue-button-md" (click)="onSaveSingle(9)">
              Save
            </button>
            <button class="white-button-md" (click)="openEditor(9, true)">
              Cancel
            </button>
          </div>
        </ng-template>
      </div>

      <!-- Website and Social Links -->
      <div
        class="card shadow-sm mb-4"
        style="border-radius: 8px; border: none; padding: 32px"
      >
        <!-- View Mode-->
        <ng-container *ngIf="!editorOpened[10]; else editWebSocialMode">
          <div
            class="d-flex justify-content-between align-items-center px-3 pt-3 pb-2"
          >
            <label class="header mb-0">Website and Social Links</label>
            @if(!public){

            <button class="btn btn-sm btn_fixed" (click)="openEditor(10)">
              <img
                src="./assets/images/icon/edit_icon_active.svg"
                alt="edit"
                class="me-1"
              />
              Update
            </button>

            }
          </div>

          <label class="sub-header mb-1 px-3">Website</label>
          <div class="meta_container px-3 py-2 mb-3 address-row">
            <ng-container *ngIf="editedNgoBody?.website; else noWebData">
              <span>
                <img
                  src="./assets/images/icon/web_icon.svg"
                  alt="phone"
                  class="icon"
                /><a
                  [href]="editedNgoBody?.website || '#'"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ editedNgoBody.website || "Not available" }}
                </a>
              </span>
            </ng-container>
            <ng-template #noWebData>No Data!</ng-template>
          </div>

          <label class="sub-header mb-1 px-3">Social</label>
          <div class="d-flex flex-column mb-3" style="gap: 12px">
            <!-- Facebook -->
            <div
              class="d-flex align-items-center px-3 address-row"
              style="gap: 8px"
            >
              <img
                src="./assets/images/logo/facebook_logo.svg"
                alt="Facebook"
                class="icon"
              />
              <a
                [href]="socialMedia?.facebook || '#'"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ socialMedia?.facebook || "Not available" }}
              </a>
            </div>

            <!-- Twitter -->
            <div
              class="d-flex align-items-center px-3 address-row"
              style="gap: 8px"
            >
              <img
                src="./assets/images/icon/twitter_new_brand_icon.svg"
                alt="Twitter"
                class="icon"
              />
              <a
                [href]="socialMedia?.twitter || '#'"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ socialMedia?.twitter || "Not available" }}
              </a>
            </div>

            <!-- YouTube -->
            <div
              class="d-flex align-items-center px-3 address-row"
              style="gap: 8px"
            >
              <img
                src="./assets/images/logo/youtube_logo.svg"
                alt="YouTube"
                class="icon"
              />
              <a
                [href]="socialMedia?.youtube || '#'"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ socialMedia?.youtube || "Not available" }}
              </a>
            </div>

            <!-- LinkedIn -->
            <div
              class="d-flex align-items-center px-3 address-row"
              style="gap: 8px"
            >
              <img
                src="./assets/images/logo/linkedin_logo.svg"
                alt="LinkedIn"
                class="icon"
              />
              <a
                [href]="socialMedia?.linkedin || '#'"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ socialMedia?.linkedin || "Not available" }}
              </a>
            </div>
          </div>
        </ng-container>

        <!--Edit mood-->
        <ng-template #editWebSocialMode
          ><div
            class="d-flex justify-content-between align-items-center px-3 pt-3 pb-2"
          >
            <label class="header mb-0">Update Website and Social Links</label>
          </div>

          <!-- Website -->
          <div class="px-3 py-2">
            <label class="sub-header mb-1">Website</label>
            <dx-text-box
              class="input_field"
              placeholder="Enter Website Addres"
              [showClearButton]="true"
              [(ngModel)]="editedNgoBody.website"
              ><dx-validator validationGroup="validationGrp"> </dx-validator>
            </dx-text-box>
          </div>

          <div class="px-3 py-2">
            <label class="sub-header mb-1">Facebook</label>
            <dx-text-box
              class="input_field"
              [(ngModel)]="socialMedia.facebook"
              placeholder="Type your Facebook Page/Profile link"
              [showClearButton]="true"
            >
              <dx-validator validationGroup="validationGrp"></dx-validator>
            </dx-text-box>
          </div>

          <div class="px-3 py-2">
            <label class="sub-header mb-1">LinkedIn</label>
            <dx-text-box
              class="input_field"
              [(ngModel)]="socialMedia.linkedin"
              placeholder="Type your LinkedIn Page/Profile link"
              [showClearButton]="true"
            >
              <dx-validator validationGroup="validationGrp"></dx-validator>
            </dx-text-box>
          </div>

          <div class="px-3 py-2">
            <label class="sub-header mb-1">Twitter</label>
            <dx-text-box
              class="input_field"
              [(ngModel)]="socialMedia.twitter"
              placeholder="Type your Twitter Page/Profile link"
              [showClearButton]="true"
            >
              <dx-validator validationGroup="validationGrp"></dx-validator>
            </dx-text-box>
          </div>

          <div class="px-3 py-2">
            <label class="sub-header mb-1">YouTube</label>
            <dx-text-box
              class="input_field"
              [(ngModel)]="socialMedia.youtube"
              placeholder="Type your YouTube channel/Profile link"
              [showClearButton]="true"
            >
              <dx-validator validationGroup="validationGrp"></dx-validator>
            </dx-text-box>
          </div>

          <div *ngIf="editorOpened[10]" class="save_button_div">
            <button class="blue-button-md" (click)="onSaveSingle(10)">
              Save
            </button>
            <button class="white-button-md" (click)="openEditor(10, true)">
              Cancel
            </button>
          </div>
        </ng-template>
      </div>

      <!-- Sustainable Development Goals (SDGs) -->
      <div
        class="card shadow-sm mb-4"
        style="border-radius: 8px; border: none; padding: 32px"
      >
        <!-- View Mode -->
        <ng-container *ngIf="!editorOpened[6]; else editMode">
          <div
            class="d-flex justify-content-between align-items-center px-3 pt-3 pb-2"
          >
            <label class="header mb-0"
              >Sustainable Development Goals (SDGs)</label
            >
            @if(!public){

            <button class="btn btn-sm btn_fixed" (click)="openEditor(6)">
              <img
                src="./assets/images/icon/edit_icon_active.svg"
                alt="edit"
                class="me-1"
              />
              Update
            </button>

            }
          </div>

          <div class="meta_container px-3 py-2">
            <label class="sub-header d-block mb-2">SDGs</label>
            <div>
              <ng-container *ngIf="editedNgoBody?.ngo_sdg; else noData">
                <span
                  *ngFor="let sdg of editedNgoBody.ngo_sdg.split(',')"
                  class="item_tag"
                >
                  {{ sdg.trim() }}
                </span>
              </ng-container>
              <ng-template #noData>No Data!</ng-template>
            </div>
          </div>
        </ng-container>

        <!-- Edit Mode -->
        <ng-template #editMode>
          <div
            class="d-flex justify-content-between align-items-center px-3 pt-3 pb-2"
          >
            <label class="header mb-0"
              >Update Sustainable Development Goals (SDGs)</label
            >
          </div>

          <div class="px-3 py-2">
            <label class="sub-header mb-1">
              SDGs <span class="required-star" style="color: red">*</span>
            </label>
            <dx-tag-box
              style="min-height: 40px"
              class="myTextBox hide-tags"
              [dataSource]="sdgList"
              placeholder="Select SDG"
              [showClearButton]="true"
              [searchEnabled]="true"
              [searchTimeout]="100"
              [showDropDownButton]="true"
              [multiline]="true"
              selectAllMode="allPages"
              [displayExpr]="'title'"
              [valueExpr]="'title'"
              [(value)]="ngoSdg"
            >
              <dx-validator validationGroup="validationGrp">
                <dxi-validation-rule
                  type="required"
                  message="SDG is required"
                ></dxi-validation-rule>
              </dx-validator>
            </dx-tag-box>
            <div class="meta_note mt-1">
              Note: You can select multiple SDGs.
            </div>
          </div>

          <div *ngIf="editorOpened[6]" class="save_button_div">
            <button class="blue-button-md" (click)="onSaveSingle(6)">
              Save
            </button>
            <button class="white-button-md" (click)="openEditor(6, true)">
              Cancel
            </button>
          </div>
        </ng-template>
      </div>

      <!-- Cause Area -->
      <div
        class="card shadow-sm mb-4"
        style="border-radius: 8px; border: none; padding: 32px"
      >
        <!-- View Mode -->
        <ng-container *ngIf="!editorOpened[8]; else causeAreaEditMode">
          <div
            class="d-flex justify-content-between align-items-center px-3 pt-3 pb-2"
          >
            <label class="header mb-0">Cause Area</label>
            @if(!public){

            <button class="btn btn-sm btn_fixed" (click)="openEditor(8)">
              <img
                src="./assets/images/icon/edit_icon_active.svg"
                alt="edit"
                class="me-1"
              />
              Update
            </button>

            }
          </div>

          <div class="meta_container px-3 py-2">
            <label class="sub-header mb-1">Category</label>
            <div>
              <ng-container *ngIf="parsedCauseArea?.length; else noData">
                <span *ngFor="let item of parsedCauseArea" class="item_tag">
                  {{ item.category }}
                </span>
              </ng-container>
            </div>
            <ng-template #noData>No Data!</ng-template>
          </div>

          <div class="meta_container px-3 py-2">
            <label class="sub-header mb-1">Sub Category</label>
            <div>
              <ng-container *ngIf="parsedCauseArea?.length; else noData">
                <span *ngFor="let area of parsedCauseArea">
                  <span *ngFor="let sub of area.subcategories" class="item_tag">
                    {{ sub }}
                  </span>
                </span>
              </ng-container>
            </div>
            <ng-template #noData>No Data!</ng-template>
          </div>
        </ng-container>

        <!-- Edit Mode -->
        <ng-template #causeAreaEditMode>
          <div
            class="d-flex justify-content-between align-items-center px-3 pt-3 pb-2"
          >
            <label class="header mb-0">Update Cause Area</label>
          </div>

          <!-- Dynamic Category-Subcategory Rows -->
          <div
            *ngFor="let item of causeAreas; let i = index"
            class="d-flex gap-3 align-items-start px-3 py-2 border-bottom"
          >
            <!-- Category -->
            <div class="flex-fill">
              <label class="sub-header mb-1">
                Category <span class="required-star text-danger">*</span>
              </label>
              <dx-tag-box
                style="min-height: 40px"
                [dataSource]="item.availableCategories"
                placeholder="Select Category"
                [showClearButton]="true"
                [showDropDownButton]="true"
                [multiline]="false"
                [displayExpr]="'title'"
                [valueExpr]="'id'"
                [(value)]="item.category"
                (onValueChanged)="onCategoryChanged($event, i)"
              >
                <dx-validator validationGroup="validationGrp">
                  <dxi-validation-rule
                    type="required"
                    message="Category is required"
                  ></dxi-validation-rule>
                </dx-validator>
              </dx-tag-box>
              <div class="meta_note mt-1">
                Note: You can select only one item
              </div>
            </div>

            <!-- Sub Category -->
            <div class="flex-fill">
              <label class="sub-header mb-1">
                Sub Category <span class="required-star text-danger">*</span>
              </label>
              <dx-tag-box
                style="min-height: 40px"
                [dataSource]="item.availableSubcategories"
                placeholder="Select Sub Category"
                [showClearButton]="true"
                [showDropDownButton]="true"
                [searchEnabled]="true"
                [multiline]="true"
                [displayExpr]="'title'"
                [valueExpr]="'id'"
                [(value)]="item.subcategories"
              >
                <dx-validator validationGroup="validationGrp">
                  <dxi-validation-rule
                    type="required"
                    message="subcategory is required"
                  ></dxi-validation-rule>
                </dx-validator>
              </dx-tag-box>
              <div class="meta_note mt-1">
                Note: You can select multiple items.
              </div>
            </div>

            <!-- Remove button -->
            <div class="d-flex align-items-end pb-2">
              <button
                class="btn btn-outline-danger btn-sm"
                *ngIf="causeAreas.length > 1"
                (click)="removeCategory(i)"
              >
                Remove
              </button>
            </div>
          </div>

          <!-- Add Another Category Button -->
          <div class="px-3 py-2">
            <button
              class="btn btn-outline-primary btn-sm"
              (click)="addCategory()"
            >
              + Add another category
            </button>
          </div>

          <!-- Action Buttons -->
          <div class="save_button_div">
            <button class="blue-button-md" (click)="onSaveSingle(8)">
              Save
            </button>
            <button class="white-button-md" (click)="openEditor(8, true)">
              Cancel
            </button>
          </div>
        </ng-template>
      </div>

      <!-- Search Aliases -->
      <div
        class="card shadow-sm mb-4"
        style="border-radius: 8px; border: none; padding: 32px"
      >
        <!-- View Mode -->
        <ng-container *ngIf="!editorOpened[7]; else editModeSearchAliases">
          <div
            class="d-flex justify-content-between align-items-center px-3 pt-3 pb-2"
          >
            <label class="header mb-0">Search Aliases</label>
            @if(!public){

            <button class="btn btn-sm btn_fixed" (click)="openEditor(7)">
              <img
                src="./assets/images/icon/edit_icon_active.svg"
                alt="edit"
                class="me-1"
              />
              Update
            </button>
            }
          </div>

          <div class="meta_container px-3 py-2">
            <label class="sub-header mb-1">Tags</label>
            <div>
              <ng-container *ngIf="editedNgoBody?.tags; else noData">
                <span
                  *ngFor="let tag of editedNgoBody.tags.split(',')"
                  class="item_tag"
                >
                  {{ tag.trim() }}
                </span>
              </ng-container>
            </div>
            <ng-template #noData>No tags found!</ng-template>
          </div>
        </ng-container>

        <!-- Edit Mode -->
        <ng-template #editModeSearchAliases>
          <div
            class="d-flex justify-content-between align-items-center px-3 pt-3 pb-2"
          >
            <label class="header mb-0">Update Search Aliases</label>
          </div>

          <div class="px-3 py-2">
            <label class="sub-header mb-1">
              Tags <span class="required-star" style="color: red">*</span>
            </label>
            <dx-tag-box
              style="min-height: 40px"
              class="myTextBox"
              [acceptCustomValue]="true"
              placeholder="Add a tag..."
              [showClearButton]="true"
              [applyValueMode]="'instantly'"
              [multiline]="true"
              [showDropDownButton]="false"
              [searchEnabled]="false"
              [showSelectionControls]="false"
              [openOnFieldClick]="false"
              [(value)]="ngoTags"
            >
              >
              <dx-validator validationGroup="validationGrp">
                <dxi-validation-rule
                  type="required"
                  message="Tag is required"
                ></dxi-validation-rule>
                <dxi-validation-rule
                  type="custom"
                  [validationCallback]="validateAllowedCharacters"
                  message="Tag contains invalid characters"
                ></dxi-validation-rule>
                <dxi-validation-rule
                  type="custom"
                  [validationCallback]="validateMaxTagLength"
                  message="Each tag can be maximum 30 characters"
                ></dxi-validation-rule>
                <dxi-validation-rule
                  type="custom"
                  [validationCallback]="validateMaxNumberTags"
                  message="Maximum 10 tags allowed"
                ></dxi-validation-rule>
                <dxi-validation-rule
                  type="custom"
                  [validationCallback]="validateDuplicates"
                  message="Duplicate tags are not allowed"
                ></dxi-validation-rule>
              </dx-validator>
            </dx-tag-box>
            <div class="meta_note mt-1">
              Allowed: A–Z, a–z, 0–9, spaces, hyphen (-), ampersand (&),
              apostrophe (’).<br />
              Not allowed: Other special characters (! &#64; # $ % ^ * ( )
              {{ "{" }} {{ "}" }} [ ])<br />
              Max length: 30 characters per tag (including spaces).<br />
              Max number: Up to 10 tags per NGO profile.
            </div>
          </div>

          <div class="save_button_div">
            <button class="blue-button-md" (click)="onSaveSingle(7)">
              Save
            </button>
            <button class="white-button-md" (click)="openEditor(7, true)">
              Cancel
            </button>
          </div>
        </ng-template>
      </div>

      <!-- Annual Report -->
      @if(editedNgoBody?.ngo_profile_id || !public){
      <div
        class="card shadow-sm mb-4"
        style="border-radius: 8px; border: none; padding: 32px"
      >
        <!-- View Mode -->
        <ng-container *ngIf="!editorOpened[14]; else editAnnualReport">
          <div
            class="d-flex justify-content-between align-items-center px-3 pt-3 pb-2 mb-4"
          >
            <label class="header mb-0">Annual Report</label>
            @if(!public){

            <button class="btn btn-sm btn_fixed" (click)="openEditor(14)">
              <img
                src="./assets/images/icon/edit_icon_active.svg"
                alt="edit"
                class="me-1"
              />
              Update
            </button>
            }
          </div>

          @if(annualReports?.length === 0){
          <p class="text-gray mb-2 px-3" style="font-size: 0.9rem">
            No annual report found!
          </p>
          }@else {
          <div
            class="meta_container px-3 py-2"
            style="margin-bottom: 32px"
            *ngFor="let report of annualReports"
          >
            <div style="display: flex; flex-direction: column; gap: 16px">
              <div class="report_title">
                {{ report?.report_title }}
              </div>

              <div>
                <span>
                  <img
                    src="./assets/images/icon/pdf-02.svg"
                    style="margin-right: 8px"
                    alt="pdf_icon"
                  />
                </span>
                <span
                  class="report_title"
                  style="color: #0056ac; font-weight: 400"
                >
                  <a [href]="report.report_url?.url" target="_blank">{{
                    report.report_url?.originalname
                  }}</a>
                </span>
              </div>
            </div>
          </div>
          <div class="text-center mt-2" *ngIf="allAnnualReports.length > 4">
            <button class="btn btn-link" (click)="toggleShowAll()">
              {{ showAll ? "See Less" : "See More" }}
            </button>
          </div>
          }
        </ng-container>

        <ng-template #editAnnualReport>
          <div
            class="d-flex flex-column justify-content-between align-items-start px-3 pt-3 pb-2 mb-4"
          >
            <label class="header" style="margin-bottom: 32px">
              Add Annual Report
            </label>

            <div class="form-group mb-4">
              <label class="sub-header requiredMark mb-4">Report Name</label>

              <dx-text-box
                class="input_field mb-2"
                [(ngModel)]="annualReportModel.report_title"
                placeholder="Enter Report Name"
              >
                <dx-validator validationGroup="reportValidationGrp">
                  <dxi-validation-rule
                    type="required"
                    message="Report name is required"
                  >
                  </dxi-validation-rule>
                  <dxi-validation-rule
                    type="stringLength"
                    [max]="100"
                    message="Note: Max 100 characters."
                  >
                  </dxi-validation-rule>
                </dx-validator>
              </dx-text-box>
              <div class="file-format-required">Note: Max 100 characters.</div>
            </div>

            <div class="form-group">
              <label class="sub-header requiredMark mb-4"> Report File </label>
              <div
                class="file-upload-container mb-2"
                (drop)="onDropSuccess($event, 'ngoRegCertificate')"
                (dragover)="onDragOver($event)"
              >
                <label
                  for="ngoFileInput"
                  style="width: 100%"
                  *ngIf="!ngoRegCertificate"
                >
                  <dx-text-box
                    class="uploader_input_field"
                    [value]="annualReportModel.report_url"
                    text="Drag and drop files here or browse file"
                    [readOnly]="true"
                  >
                    <dx-validator validationGroup="reportValidationGrp">
                      <dxi-validation-rule
                        type="required"
                        message="Annual Report In PDF format is required."
                      >
                      </dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                  <input
                    #ngoFileInput
                    class="box-file"
                    type="file"
                    id="ngoFileInput"
                    (change)="onPdfFileSelected($event, 'ngoRegCertificate')"
                    aria-hidden="true"
                    accept=".pdf"
                  />
                </label>

                <div
                  *ngIf="!ngoRegCertificate"
                  class="blue-button-md"
                  type="button"
                  (click)="triggerFileInput('ngoFileInput')"
                >
                  Browse File
                </div>

                <div *ngIf="ngoRegCertificate" class="upload-file">
                  <span>{{ ngoRegCertificate.name }}</span>
                  <button
                    type="button"
                    (click)="removeFile('ngoRegCertificate')"
                    class="remove-file-button"
                  >
                    <img src="../../../../assets/images/icon/cross-icon.svg" />
                  </button>
                </div>
              </div>
              <div class="file-format-required">
                Note: Files should be in PDF format.
              </div>
              <div class="button-side" style="margin-top: 16px">
                <dx-button [disabled]="true" class="white-button-md"
                  >Add Another</dx-button
                >
                <div style="display: flex; flex-direction: row; gap: 8px">
                  <dx-button
                    class="yellow-button-md next-button"
                    type="button"
                    (click)="submit(14)"
                  >
                    Save
                  </dx-button>
                  <dx-button
                    class="blue-button-md next-button"
                    type="button"
                    (click)="openEditor(14, true)"
                  >
                    Cancel
                  </dx-button>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
      }

      <!--Awards & Recognition-->
      @if (editedNgoBody?.ngo_profile_id || !public) {

      <div
        class="card shadow-sm mb-4"
        style="border-radius: 8px; border: none; padding: 32px"
      >
        <!-- View Mode -->
        <ng-container *ngIf="!editorOpened[13]; else editAward">
          <div
            class="d-flex justify-content-between align-items-center px-3 pt-3 pb-2"
          >
            <label class="header mb-0">Awards & Recognition</label>
            @if(!public){

            <button class="btn btn-sm btn_fixed" (click)="openEditor(13)">
              <img
                src="./assets/images/icon/edit_icon_active.svg"
                alt="edit"
                class="me-1"
              />
              Update
            </button>

            }
          </div>

          @if(awardData?.length === 0){
          <p class="text-gray mb-2 px-3" style="font-size: 0.9rem">
            No awards found!
          </p>
          }@else{
          <div class="meta_container px-3 py-2">
            <dx-data-grid
              class="custom-award-grid"
              [dataSource]="showAll2 ? allAwardData : awardData"
              [columns]="columns"
              [showBorders]="false"
              [columnAutoWidth]="true"
              [wordWrapEnabled]="true"
            >
            </dx-data-grid>
          </div>
          <div class="text-center mt-2" *ngIf="allAwardData.length > 4">
            <button class="btn btn-link" (click)="updateVisibleAwards()">
              {{ showAll2 ? "See Less" : "See More" }}
            </button>
          </div>
          }
        </ng-container>

        <ng-template #editAward>
          <div
            class="d-flex flex-column justify-content-between align-items-start px-3 pt-3 pb-2 mb-4"
          >
            <label class="header" style="margin-bottom: 32px">
              Add New Award
            </label>

            <div class="form-group mb-4">
              <label class="sub-header requiredMark mb-4">Award Name</label>

              <dx-text-box
                class="input_field mb-2"
                [(ngModel)]="ngoAwardModel.award_name"
                placeholder="Enter Award Name"
              >
                <dx-validator validationGroup="awardValidationGrp">
                  <dxi-validation-rule
                    type="required"
                    message="Award name is required"
                  >
                  </dxi-validation-rule>
                  <dxi-validation-rule
                    type="stringLength"
                    [max]="100"
                    message="Note: Max 100 characters."
                  >
                  </dxi-validation-rule>
                </dx-validator>
              </dx-text-box>
              <div class="file-format-required">Note: Max 100 characters.</div>
            </div>

            <div class="form-group mb-4">
              <label class="sub-header requiredMark mb-4">Recipient Name</label>

              <dx-text-box
                class="input_field mb-2"
                [(ngModel)]="ngoAwardModel.participant"
                placeholder="Enter Recipient Name"
              >
                <dx-validator validationGroup="awardValidationGrp">
                  <dxi-validation-rule
                    type="required"
                    message="Recipient name is required"
                  >
                  </dxi-validation-rule>
                  <dxi-validation-rule
                    type="stringLength"
                    [max]="100"
                    message="Note: Max 100 characters."
                  >
                  </dxi-validation-rule>
                </dx-validator>
              </dx-text-box>
              <div class="file-format-required">Note: Max 100 characters.</div>
            </div>

            <div class="form-group mb-4">
              <label class="sub-header requiredMark mb-4">Year</label>

              <dx-text-box
                class="input_field mb-2"
                [(ngModel)]="ngoAwardModel.year"
                placeholder="Enter Award Name"
              >
                <dx-validator validationGroup="awardValidationGrp">
                  <dxi-validation-rule
                    type="required"
                    message="Year is required"
                  >
                  </dxi-validation-rule>
                </dx-validator>
              </dx-text-box>
              <div class="file-format-required">Note: Max 4 numbers.</div>
            </div>
            <div style="display: flex; flex-direction: row; gap: 8px">
              <dx-button
                class="yellow-button-md next-button"
                type="button"
                (click)="submit(13)"
              >
                Save
              </dx-button>
              <dx-button
                class="blue-button-md next-button"
                type="button"
                (click)="openEditor(13, true)"
              >
                Cancel
              </dx-button>
            </div>
          </div>
        </ng-template>
      </div>

      }
    </div>
  </div>
</div>
